import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
  loadingModal: boolean = false
  model: any = {
    title: '¿Confirma realizar la acción?',
    description: '',
    cancelText: 'Cancelar',
    confirmText: 'Confirmar'
  };

  constructor( 
    @Inject(MAT_DIALOG_DATA) 
    public data: any, 
    public dialogRef: MatDialogRef<ConfirmDialogComponent>) {
    if(data){
      this.model = Object.assign(this.model, data)
    }
  }

  ngOnInit() { }

  // Cierras el modal con el event 2 para que el padre sepa que no se puede enviar al back la data
  cancel() {
    this.dialogRef.close({exito: false});
  }
  // Cierras el modal con el event 1 para que el padre sepa que se puede enviar al back la data
  confirm(){
    this.loadingModal = true
    this.dialogRef.close({exito: true});
  }
}
